module.exports = __webpack_public_path__ + "img/wifi-router.f282d81.webp";